<template>
  <span>
    <label class="formLabel">
      {{ name }}
    </label>
    <div class="relative">
      <select
        class="font-sansBold uppercase block appearance-none w-full border text-white py-1 px-4 pr-8 leading-tight focus:outline-none focus:bg-black focus:border-black"
        :class="{
          'bg-gray-900': disabled,
          'hover:bg-gray-900 bg-black':!disabled,
          'border-red-500 ':error,
          'border-black':!error
        }"
        :disabled="disabled"
        :value="value"
        @change="change($event.target.value)"
      >
        <option
          v-for="(option, index) in options" :key="index" :value="option.value"
          class="bg-black border-black"
        >
          {{ option.label }}
        </option>
      </select>
      <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-white">
        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
      </div>
    </div>
    <p v-if="error" class="text-red-500 text-xs italic py-2">{{ errorMsg }}</p>
  </span>
</template>

<script>
export default {
  name: 'CustomSelect',
  props: {
    name: String,
    value: String,
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    errorMsg: {
      type: String,
      default: 'Required'
    },
    options: {
      type: Array,
      required: true
    }
  },
  methods: {
    change (val) {
      this.$emit('input', val)
    }
  }
}
</script>
